import React from 'react';
import { Link } from 'react-router-dom';
import { faAngleRight, faTimes } from '@fortawesome/pro-regular-svg-icons';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import './banner.css';

const NycBanner = ({ display, closeBanner }) => (
  <div className="banner">
    <div className="banner__container container">
      <div className="banner__content">
        <div className="banner__details">BOOKING SYSTEM SUSPENDED: We are currently resolving an administrative issue with the NY DMV. You will be unable to make a booking during this time. This is temporary and should be resolved shortly.</div>
        <Link to="./nyc-dmv-issue">
          <div className="banner__read-more"> Read more</div>
          <FontAwesomeIcon icon={faAngleRight} fixedWidth size="1x" />
        </Link>
      </div>
      <div className="banner__close" onClick={closeBanner}>
        <FontAwesomeIcon icon={faTimes} fixedWidth size="1x" />
      </div>
    </div>
  </div>
);

export default NycBanner;



// WEBPACK FOOTER //
// ./src/components/Layout/NycBanner.js